import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ReactPlayer from "react-player";
import { Typography, Box, Stack,CardMedia } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import parse from 'html-react-parser'
import { Videos, Loader } from "./";
import { fetchFromAPI } from "../utils/fetchFromAPI";
import { margin } from "@mui/system";
import defaultLogo from "../imgs/youtube-square-logo-3F9D037665-seeklogo.com.png"

const VideoDetail = () => {
  const [comment,setComment] = useState(null)
  const [videoDetail, setVideoDetail] = useState(null);
  const [videos, setVideos] = useState(null);
  const { id } = useParams();
  const [showMoreStatus, setShowMoreStatus] = useState(false);


  useEffect(() => {
    setShowMoreStatus(true);

    fetchFromAPI(`videos?part=snippet,statistics&id=${id}`)
      .then((data) => setVideoDetail(data.items[0]))

    fetchFromAPI(`search?part=snippet&relatedToVideoId=${id}&type=video`)
      .then((data) => setVideos(data.items))

      fetchFromAPI(`commentThreads?part=snippet&videoId=${id}&maxResults=20`)
      .then((data) => {
        setComment(data.items)
        console.log(data.items)
      })

  }, [id]);


  const more = {
    minHeight:"6rem",
    overflow:"hidden",
    margin:2,
    // processing: '#F0E666',
  }

  const less = {
    maxHeight:"4rem",
    overflow:"hidden",
    margin:2,
    // cursor:"pointer"
    // processing: '#F0E666',
  }

  if(!videoDetail?.snippet) return <Loader />;

  const { snippet: { description,title, channelId, channelTitle }, statistics: { viewCount, likeCount,commentCount } } = videoDetail;

  return (
    <Box sx={{ overflowY: "auto", flex: 2, height: "80vh" }}>
      <Stack direction={{ xs: "column", md: "row" }}>
        <Box flex={1}>
          <Box sx={{ width: "100%",  top: "86px" }}>
            <ReactPlayer url={`https://www.youtube.com/watch?v=${id}`} className="react-player" controls />
            <Typography color="#fff" variant="h5" fontWeight="bold" p={2}>
              {title}
            </Typography>
            <Stack direction="row" justifyContent="space-between" sx={{ color: "#fff" }} py={1} px={2} >
              <Link to={`/channel/${channelId}`}>
                <Typography variant={{ sm: "subtitle1", md: 'h6' }}  color="#fff" >
                  {channelTitle}
                  <CheckCircleIcon sx={{ fontSize: "12px", color: "gray", ml: "5px" }} />
                </Typography>
              </Link>
              <Stack direction="row" gap="20px" alignItems="center">
                <Typography variant="body1" sx={{ opacity: 0.7 }}>
                  {parseInt(viewCount).toLocaleString()} views
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.7 }}>
                  {parseInt(likeCount).toLocaleString()} likes
                </Typography>
              </Stack>


            </Stack>

            <Stack borderRadius="12px" sx={{ backgroundColor:"rgba(255,255,255,0.1)","&:hover":{backgroundColor:"rgba(255,255,255,0.2)"}}}>
              <Box sx={!showMoreStatus ? more : less}>
                  <span style={{
                    fontFamily: `"Roboto", sans-serif`,
                    color:"white",
                    whiteSpace:"pre-wrap",
                    maxWidth:"640px",
                    
                  }}
                     
                  >
                    {description}
                  </span>
              </Box>
            
              <Box >
                <Typography className="uppercase text-sm cursor-pointer"
                  onClick={() => setShowMoreStatus(!showMoreStatus)}
                  color="white"
                  sx={{cursor:"pointer", margin:2}}
                  
                >
                  <pre display="block">
                    Show {!showMoreStatus ? "less" : "more"}
                  </pre>
                  
                </Typography>
              </Box>
            

            {/* comment */}

           
            
            </Stack>
              <Typography  color="white" variant="body1" sx={{ opacity: 1,padding:2 }}>

                <span color="white">{commentCount} Commments</span>
              </Typography>
             
            <Stack>
              <Stack>

             
                <Box>
                  {comment&&comment.map((item, idx) => (
                  <Box padding={1}>
                    <Stack direction="row" sx={{gap:"8px"}}>
                      <CardMedia
                        image={defaultLogo}
                        sx={{borderRadius: '50%', height: '35px', width: '35px',margin:1}}
                      />
                      <Stack sx={{maxWidth:"566px"}}>
                        
                        <Typography color="white" variant="body1" sx={{ opacity: 1 }}>
                          <span>
                          @{item?.snippet?.topLevelComment?.snippet?.authorDisplayName}
                          </span>
                          


                        </Typography>

                        <Typography color="white" variant="body1" sx={{ opacity: 0.7,whiteSpace:"pre-wrap" }}>
                          <span >{parse(item?.snippet?.topLevelComment?.snippet?.textDisplay)}</span>


                        </Typography>
                        <br/>
                      </Stack>


                    </Stack>
                     
                    
                  </Box>
                  
                ))}

                </Box>
                
              </Stack>
              

            </Stack>
          </Box>
        </Box>
        <Box px={2} py={{ md: 1, xs: 5 }} justifyContent="center" alignItems="center" >
          <Videos videos={videos} direction="column" />
        </Box>
      </Stack>

      
    </Box>
  );
};

export default VideoDetail;